import React, { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { LayoutComponent_LocalLoader as LocalLoader } from 'ggApp/modules/layout';
import BundleWidget from 'ggApp/shared/components/BundleWidget/BundleWidget';
import ProductBundleQuery from 'ggApp/shared/screens/ProductDetailsPage/queries/ProductBundleQuery.graphql';

const BundleSection = ({
    selectedRentalPlan,
    activeStore,
    currentVariant,
    currentProductId,
    isDesktopUser,
    registerBundleImpression,
    registerAddBundleToCart,
    className,
    handleCtaClick,
    onCompleted,
}) => {
    const { loading, data: { product } = {} } = useQuery(ProductBundleQuery, {
        variables: { productId: currentProductId },
        onCompleted,
        onError: onCompleted,
    });

    const { id: bundleID, secondaryProducts } = product?.bundle || {};

    const isBundleAvailable = product?.bundle?.active;

    const handleIntersect = useCallback(
        (bundleContent) => {
            if (bundleContent) {
                registerBundleImpression({
                    isBundleAvailable,
                    bundleContent,
                    bundleID: product?.bundle?.id,
                });
            }
        },
        [isBundleAvailable, product, registerBundleImpression],
    );

    const handleBundleCtaClick = useCallback(
        ({ bundleContent, callback }) => {
            handleCtaClick({
                items: bundleContent?.products,
                callback,
                voucher: bundleContent?.discount,
            });
        },
        [handleCtaClick],
    );

    return (
        <div className={className}>
            {isBundleAvailable ? (
                <BundleWidget
                    mainProduct={product}
                    secondaryProducts={secondaryProducts}
                    selectedRentalPlan={selectedRentalPlan}
                    activeStore={activeStore}
                    currentVariant={currentVariant}
                    isDesktopUser={isDesktopUser}
                    registerAddBundleToCart={registerAddBundleToCart}
                    handleBundleCtaClick={handleBundleCtaClick}
                    handleIntersect={handleIntersect}
                    bundleID={bundleID}
                />
            ) : (
                <LocalLoader active={loading} />
            )}
        </div>
    );
};

export default BundleSection;
